import PropTypes from 'prop-types';
import React from 'react';

import Checkbox from 'core/gd-components/checkbox/checkbox.tsx';

import Moment from 'moment';
import Classes from 'classnames';

class FileItem extends React.Component {

    static propTypes = {
        id: PropTypes.string,
        mimeType: PropTypes.string,
        iconLink: PropTypes.string,
        name: PropTypes.string,
        size: PropTypes.string,
        modifiedTime: PropTypes.string,
        webViewLink: PropTypes.string,
        thumbnailLink: PropTypes.string,

        checked: PropTypes.bool,

        onFolderClick: PropTypes.func,
        onCheckClick: PropTypes.func,
        onDeleteClick: PropTypes.func
    };

    onFolderClick = () => {
        const { id, name, onFolderClick } = this.props;
        if (onFolderClick) onFolderClick(id, name);
    };

    onCheckClick = () => {
        const { id, name, mimeType, iconLink, modifiedTime, size, webViewLink, onCheckClick } = this.props;
        if (onCheckClick) onCheckClick({
            storageProvider     : 100, //GOOGLE_DRIVE = 100  DROPBOX = 101
            fileId              : id,
            fileName            : name,
            mimeType            : mimeType,
            thumbnailLink       : this.props.thumbnailLink,
            //iconLink: iconLink,
            //modifiedTime: modifiedTime,
            size                : size,
            //webViewLink: webViewLink,
        });
    };

    /*onDeleteClick(e) {
        e.stopPropagation();
        const { id, onDeleteClick } = this.props;
        if (onDeleteClick) onDeleteClick(id);
    },*/

    renderFolder = () => {
        const { iconLink, name } = this.props;

        return (
            <div className="file-item is-folder" onClick={this.onFolderClick}>

                <div className="column file-item-title">
                    <img className="file-item-icon" src={iconLink}/>
                    {name}
                </div>
                {/*<div className="delete-button i5-delete" onClick={this.onDeleteClick}> </div>*/}
            </div>
        );
    };

    renderFile = () => {
        const { id, iconLink, name, size, modifiedTime, checked } = this.props;

        const sizeLabel = size ? gd.utils.roundToDecimals(parseInt(size)/Math.pow(1024,2), 3) + " Mb" : "";
        const timeLabel = modifiedTime ? Moment(modifiedTime).format("MMM DD, YYYY; HH:mm ") : "";

        const upladingClasses = Classes("column", "file-item-uploading", {
            hidden: modifiedTime
        });

        return (
            <div className="file-item">
                {id && <Checkbox className="file-item-checkbox"
                                 isChecked={checked}
                                 onClick={this.onCheckClick}/>}

                <div className="column file-item-title" onClick={this.onCheckClick}>
                    {iconLink && <img className="file-item-icon" src={iconLink}/>}
                    {name}
                </div>

                <div className={upladingClasses}>Uploading...</div>
                <div className="column file-item-size">{sizeLabel}</div>
                <div className="column file-item-date">{timeLabel}</div>

                {/*<div className="delete-button i5-delete" onClick={this.onDeleteClick}> </div>*/}
            </div>
        );
    };

    render() {
        const typeLabel = this.props.mimeType.indexOf("folder") !== -1 ? "folder" : "file";

        switch (typeLabel) {
            case "folder": return this.renderFolder();
            case "file": return this.renderFile();
        }
    }
}

module.exports = FileItem;